import React from 'react'
import { Flex, Box, Image } from '@chatterbug/aaron'
import routes from 'src/lib/rails-routes/rails-routes'
import { t } from 'src/lib/i18n-react'
import Pressable from 'src/ui/Pressable/Pressable'

import avatarBlocked from './assets/avatar_blocked.svg'
import TutorRatingIcon from './subcomponents/TutorRatingIcon/TutorRatingIcon'

export type SimpleTutorInfoType = {
  name: string
  login: string
  avatarUrl: string
  tutor: {
    countOfJointLiveLessons: number
    isFavorite: boolean
    isBlocked: boolean
  }
}

const overflowStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: '100%',
  textAlign: 'center',
}

export type Props = SimpleTutorInfoType & {
  onClick?: () => void
  onOrderChange?: () => void
  customStyle?: Record<string, unknown>
}

const SimpleTutorInfoCard: React.FC<Props> = ({
  name,
  login,
  avatarUrl,
  tutor,
  onClick,
  onOrderChange,
  customStyle,
}) => {
  const {
    countOfJointLiveLessons: countOfLessons,
    isFavorite,
    isBlocked,
  } = tutor

  return (
    <Flex
      position="relative"
      py="2x"
      px="1x"
      borderRadius="1x"
      bg="white100"
      boxShadow="raised"
      justifyContent="center"
      data-testid="simple-tutor-info-card"
      {...customStyle}
    >
      <Box
        sx={{
          position: 'absolute',
          right: '5px',
          top: '5px',
        }}
      >
        <TutorRatingIcon
          isFavorite={isFavorite}
          isBlocked={isBlocked}
          name={name}
          login={login}
          onChangeTutorRating={onClick}
          onOrderChange={onOrderChange}
        />
      </Box>

      <Pressable
        linkUrl={routes.profile({ login: login })}
        display="flex"
        width="100%"
        flexDirection="column"
        alignItems="center"
        altText={t('Tutor info of %{name}', { name })}
        disabled={false}
        onClick={null}
      >
        <Image
          src={isBlocked ? avatarBlocked : avatarUrl}
          mb="1x"
          width="72px"
          height="72px"
          data-testid="tutor-avatar"
          sx={{
            borderRadius: '100%',
            objectFit: 'cover',
          }}
          alt={t('Blocked tutor')}
        />

        <Box as="p" variant="text.h5" mb="0,5x" sx={{ ...overflowStyle }}>
          {name}
        </Box>
        <Box as="p" variant="text.monospace" mb="1x" sx={{ ...overflowStyle }}>
          {login}
        </Box>
        {isBlocked ? (
          <Box color="gray46" fontSize="xxs">
            {t('Tutor Blocked')}
          </Box>
        ) : (
          <Box as="p" fontSize="xxs">
            {t(
              '%{smart_count} Lesson with you |||| %{smart_count} Lessons with you',
              {
                smart_count: countOfLessons,
              }
            )}
          </Box>
        )}
      </Pressable>
    </Flex>
  )
}

export default SimpleTutorInfoCard
